import { useMemo, useState } from "react";

import { useApiList } from "../api/hooks";
import type { AuditEntry } from "../api/types";

/** The table keys rows by a string id; the audit id is a bigint serial. */
type AuditRow = Omit<AuditEntry, "id"> & { id: string };
import { DataTable, fmtDate, Page, Pagination, Toolbar } from "../components/ui";

export function AuditLogPage() {
  const [entity, setEntity] = useState("");
  const [page, setPage] = useState(1);
  const query = useMemo(() => ({ entity: entity || undefined, page, per_page: 50 }), [entity, page]);
  const list = useApiList<AuditEntry & { id: string }>("/admin/audit-log", query);
  const [open, setOpen] = useState<string | null>(null);

  return (
    <Page title="Audit log">
      <Toolbar>
        <input className="input" placeholder="Entity (vendor, user, settings…)" value={entity} onChange={(e) => (setEntity(e.target.value), setPage(1))} />
      </Toolbar>
      <DataTable
        columns={[
          { key: "at", label: "When", render: (e) => fmtDate(e.at) },
          { key: "actor_name", label: "Who", render: (e) => e.actor_name ?? "system" },
          { key: "action", label: "Action", render: (e) => <span className="mono">{e.action}</span> },
          { key: "entity", label: "Entity", render: (e) => (<>{e.entity} {e.entity_id && <span className="muted mono">{e.entity_id.slice(0, 8)}…</span>}</>) },
          {
            key: "after",
            label: "Change",
            render: (e) =>
              e.after ? (
                open === e.id ? (
                  <pre className="json">{JSON.stringify(e.after, null, 2)}</pre>
                ) : (
                  <button type="button" className="btn btn-ghost btn-sm" onClick={() => setOpen(e.id)}>
                    Show
                  </button>
                )
              ) : (
                "—"
              ),
          },
        ]}
        rows={list.data.map((e): AuditRow => ({ ...e, id: String(e.id) }))}
        loading={list.loading}
        error={list.error}
      />
      <Pagination page={page} perPage={50} total={list.total} onPage={setPage} />
    </Page>
  );
}
